import React, { Component } from "react";
import styled from "styled-components";
import defaultPics from "../../../images/avatar.png";

export class Profile extends Component {
  render() {
    return (
      <ProfilePic>
        <ProfilePics src={defaultPics} />
        <button>Upload Picture</button>
      </ProfilePic>
    );
  }
}

const ProfilePic = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  svg {
    color: #0a0b69;
  }
`;

const ProfilePics = styled.img`
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
`;
export default Profile;
